import React from 'react';
import { Box } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

// Keep the native Stepper layout while giving each phase a recognizable symbol.
export default function JourneyStepIcon({ symbol: PhaseIcon, active, completed }) {
  const Icon = completed ? CheckRoundedIcon : PhaseIcon;
  return <Box component="span" aria-hidden="true" sx={{
    width: 24, height: 24, borderRadius: '50%', display: 'inline-flex',
    alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    bgcolor: active || completed ? 'primary.main' : 'action.hover',
    color: active || completed ? 'primary.contrastText' : 'text.secondary',
    outline: active ? '4px solid' : 'none', outlineColor: 'action.selected',
  }}>
    <Icon sx={{ fontSize: 16 }} />
  </Box>;
}
